








import { Component, Vue, Prop } from 'vue-property-decorator';
import videojs from 'video.js';

@Component
export default class MpVideoPlayer extends Vue {
  @Prop()
  autoplay!: boolean;

  @Prop()
  videoUrl!: boolean;

  @Prop({ default: null })
  poster!: string;

  player!: videojs.Player;

  options: any = {
    autoplay: this.autoplay,
    controls: true,
    html5: {
      hls: {
        withCredentials: true
      }
    },
    sources: [
      {
        src: this.videoUrl,
        type: 'application/x-mpegURL'
      }
    ]
  };

  mounted() {
    this.player = videojs(this.$refs.videoPlayer, this.options, () => {
      // console.log('onPlayerReady', this.player);
    });
  }

  pause() {
    if (!this.player) {
      return;
    }
    this.player.pause();
  }

  play() {
    if (!this.player) {
      return;
    }
    this.player.play();
  }

  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  }
}
